import { useState, useCallback } from 'react';
import { AlertType, AlertConfig } from '../components/common/AlertMessage';

export const useAlert = () => {
  const [alertConfig, setAlertConfig] = useState<AlertConfig | null>(null);

  const showAlert = useCallback((
    type: AlertType, 
    message: string, 
    closable?: boolean
  ) => {
    setAlertConfig({
      type,
      message,
      closable
    });
  }, []);

  const hideAlert = useCallback(() => {
    setAlertConfig(null);
  }, []);

  // 便捷方法
  const showSuccess = useCallback((message: string) => {
    showAlert('success', message);
  }, [showAlert]);

  const showError = useCallback((message: string) => {
    showAlert('error', message);
  }, [showAlert]);

  const showWarning = useCallback((message: string) => {
    showAlert('warning', message);
  }, [showAlert]);

  const showInfo = useCallback((message: string) => {
    showAlert('info', message);
  }, [showAlert]);

  return {
    alertConfig,
    showAlert,
    hideAlert,
    showSuccess,
    showError,
    showWarning,
    showInfo
  };
}; 